export const VolunteeringConstants = Object.freeze({

  FILTER_CRITERIA_IDS: {
    CATEGORY_ID: 0,
    LANGUAGES_ID: 1,
    FORMATS_ID: 2,
    LOCATION_ID: 3,
    DURATION_ID: 4,
    DEDICATION_ID: 5,
  },

  CATEGORY_KEY: 'category',
  LANGUAGE_KEY: 'language',
  FORMAT_KEY: 'format',
  LOCATION_KEY: 'location',
  DURATION_KEY: 'duration',
  DEDICATION_KEY: 'dedication',

  HYBRID_TAG_KEY: 'hybrid',

  NO_PROJECT_OFFER_KEY: 'noprojectoffer',

  PROPOSE_OFFER_FORM_URL_FR: 'https://noos.typeform.com/bnv-candidature',
  PROPOSE_OFFER_FORM_URL_EN: 'https://noos.typeform.com/vol-application',
  PROPOSE_OFFER_FORM_URL_ES: 'https://noos.typeform.com/vol-solicitud',

  INDIVIDUAL_MISSION_TYPE: 'individual' as const,
  COLLECTIVE_MISSION_TYPE: 'collective_activity' as const,
  TEAM_BUILDING_TYPE: 'team_building' as const,

  MISSION_FORMAT_ONLINE: 'online',
  MISSION_FORMAT_PRESENTIAL: 'presential',

  MISSION_STATE_PENDING: 'pending',
  MISSION_STATE_ONLINE: 'online',
  MISSION_STATE_SIGNED_UP: 'signed_up',
  MISSION_STATE_ONGOING: 'ongoing',
  MISSION_STATE_FINISHED: 'finished',
  MISSION_STATE_SENT: 'application_sent',
  MISSION_STATE_REPORT_DONE: 'report_done',

  /**
   * TB_STATUS_DEFAULT:
   * Represents that the user has not signed up for the team building.
   */
  TB_STATUS_DEFAULT: 'default',

  /**
   * TB_STATUS_NO_TIME_RANGES_AVAILABLE:
   * Indicates that there are no available time ranges (i.e., no available slots) for the team building.
   */
  TB_STATUS_NO_TIME_RANGES_AVAILABLE: 'no_time_ranges_available',

  /**
   * TB_STATUS_SIGNED_UP:
   * Represents that the user has signed up for the team building,
   * and the selected time range is scheduled to start in the future.
   */
  TB_STATUS_SIGNED_UP: 'signed_up',

  /**
   * TB_STATUS_ONGOING:
   * Means that the team building is currently in progress.
   */
  TB_STATUS_ONGOING: 'ongoing',

  /**
   * TB_STATUS_REPORT_PENDING:
   * Indicates that the team building has finished, and the user has not yet submitted the required report or feedback.
   */
  TB_STATUS_REPORT_PENDING: 'report_pending',

  /**
   * TB_STATUS_REPORT_DONE:
   * Indicates that the team building has finished and the required report or feedback has been submitted.
   */
  TB_STATUS_REPORT_DONE: 'report_done',


  /**
   * CA_STATUS_PENDING:
   * Represents that the collective activity has not been approved.
   * For the activity owner, it means the activity is still pending approval.
   */
  CA_STATUS_PENDING: 'pending',

  /**
   * CA_STATUS_ONLINE:
   * Indicates that the collective activity is approved and scheduled for a future start date.
   * For the owner, this status is shown when the activity is online and hasn't started yet.
   */
  CA_STATUS_ONLINE: 'online',

  /**
   * CA_STATUS_DEFAULT:
   * Represents that a non-owner user has not signed up for the collective activity.
   * It is the default state for a user who has not yet engaged with the activity.
   */
  CA_STATUS_DEFAULT: 'default',

  /**
   * CA_STATUS_REPORT_DONE:
   * Indicates that the collective activity has finished and the required report or feedback
   * has already been submitted by the owner.
   */
  CA_STATUS_REPORT_DONE: 'report_done',

  /**
   * CA_STATUS_FINISHED_REPORT_PENDING:
   * Shows that the collective activity has finished and the required report or feedback
   * has not yet been submitted by the owner.
   */
  CA_STATUS_FINISHED_REPORT_PENDING: 'finished_report_pending',

  /**
   * CA_STATUS_ONGOING:
   * Means that the collective activity is currently in progress.
   */
  CA_STATUS_ONGOING: 'ongoing',

  /**
   * CA_STATUS_SIGNED_UP:
   * Represents that a non-owner user has signed up for the collective activity,
   * and the activity is still scheduled to start in the future.
   */
  CA_STATUS_SIGNED_UP: 'signed_up',

  /**
   * CA_STATUS_REPORT_PENDING:
   * Means that a non-owner user has signed up for the collective activity and is viewing it
   * after its start date (or end date if available) without having submitted any report or feedback.
   */
  CA_STATUS_REPORT_PENDING: 'report_pending',

  // Collective activity creation templates

  COLLECTIVE_ACTIVITY_TEMPLATES: {
    'eco_friendly_meal': {
      'en': 'https://noos.ams3.cdn.digitaloceanspaces.com/Lunch%20is%20ready!_EN.pdf',
      'es': 'https://noos.ams3.cdn.digitaloceanspaces.com/Lunch%20is%20ready!_ES.pdf',
      'fr': 'https://noos.ams3.cdn.digitaloceanspaces.com/Lunch%20is%20ready!_FR.pdf'
    },    'waste_collection': {
      'en': 'https://noos.ams3.cdn.digitaloceanspaces.com/Cleanup%20Operation!_EN.pdf',
      'es': 'https://noos.ams3.cdn.digitaloceanspaces.com/Cleanup%20Operation!_ES.pdf',
      'fr': 'https://noos.ams3.cdn.digitaloceanspaces.com/Cleanup%20Operation!_EN.pdf'
    },    'charity_run': {
      'en': 'https://noos.ams3.cdn.digitaloceanspaces.com/On%20your%20marks_%20Ready%20to%20go_%20Get%20set!_EN.pdf',
      'es': 'https://noos.ams3.cdn.digitaloceanspaces.com/On%20your%20marks_%20Ready%20to%20go_%20Get%20set!_ES.pdf',
      'fr': 'https://noos.ams3.cdn.digitaloceanspaces.com/On%20your%20marks_%20Ready%20to%20go_%20Get%20set!_FR.pdf'
    },    'donation': {
      'en': 'https://noos.ams3.cdn.digitaloceanspaces.com/Gimme,%20gimme_EN.pdf',
      'es': 'https://noos.ams3.cdn.digitaloceanspaces.com/Gimme,%20gimme_ES.pdf',
      'fr': 'https://noos.ams3.cdn.digitaloceanspaces.com/Gimme,%20gimme_FR.pdf'
    },    'blood_drive': {
      'en': 'https://noos.ams3.cdn.digitaloceanspaces.com/Save%203%20lives%20in%201%20hour_EN.pdf',
      'es': 'https://noos.ams3.cdn.digitaloceanspaces.com/Save%203%20lives%20in%201%20hour_ES.pdf',
      'fr': 'https://noos.ams3.cdn.digitaloceanspaces.com/Save%203%20lives%20in%201%20hour_FR.pdf'
    },
  }
});
